<template>
<div>
    <div class="link-btn pt-4" @click="returnToOptions">
        <v-icon small color="primary">arrow_back_ios</v-icon> Escolher outra forma de pagamento
    </div>
    <v-layout class="mt-4">
        <label class="title-card">Pagar com</label>
        <v-img max-height="24" max-width="91" class="ml-2" flat src="https://blueticket-cdn.s3.amazonaws.com/assets/icons/ame_logo.svg"></v-img>
    </v-layout>
    <!-- <v-layout class="mt-2">
        <span class="discount">Filme em dobro! Pague com Ame e ganha outra sessão!</span>
    </v-layout> -->
    <v-layout v-if="!isSmAndDown" justify-center style="min-width: 300px; min-height: 300px;">
        <div style="padding-top: 50px;" v-if="loadingQRcode">
            <v-layout justify-center class="mt-4 mb-4">
             <span class="footer-card">Por favor Aguarde...</span>
            </v-layout>
            <v-layout justify-center>
                <half-circle-spinner class="loading-circular" :animation-duration="1000" :size="60" color="#0067af" />
            </v-layout>
        </div>
        <v-img v-else flat max-width="300" :src="ameDetails.wallet_qrcode"></v-img>
    </v-layout>
    <!-- <v-layout justify-center v-else>
        
    </v-layout> -->
    <div v-if="!isSmAndDown">
     <v-layout class="mt-2">
        <span class="subtitle-card">Pagar com AME é rápido e fácil</span>
    </v-layout>
    <v-layout class="mt-2">
        <span>1. Abra o aplicativo Ame Digital.</span>
    </v-layout>
    <v-layout>
        <span>Se você ainda não tem, baixe no Googleplay ou App Store</span>
    </v-layout>
    <v-layout class="mt-2">
        <span>2. Clique em Pagar e aponte para o QR Code acima.</span>
    </v-layout>
    <v-layout class="mt-2 mb-4">
        <span>3. Pronto, agora é só finalizar o pagamento com Ame.</span>
    </v-layout>
    </div>
    <div v-if="isSmAndDown">
        <v-layout>

        <a :href="ameDetails.wallet_link" target="_blank" style="width: 100%">
            <v-btn
                block
                round
                depressed
                class="normal-text mt-4"
                color="primary"
                dark
                :loading="ameDetails && !ameDetails.wallet_link"
                >Ja tenho app, quero pagar</v-btn>
            </a>
        </v-layout>
        <v-layout>
          <a href="https://spacey-api-v2-americanas.b2w.io/spacey-api/publication/desktop/ame-download/americanas" target="_blank" style="width: 100%">
            <v-btn
                block
                round
                outline
                class="normal-text mt-2"
                color="primary"
                dark
                :loading="ameDetails && !ameDetails.wallet_link"
                >Não tenho o app, baixar agora</v-btn>
                 </a>
        </v-layout>
    </div>
    <v-layout justify-center class="mt-2 mb-4">
        <span class="footer-card">Você será redirecionado automaticamente <p class="footer-card">após concluir sua compra na Ame</p></span>
    </v-layout>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import $http from '@/http.js';
import { HalfCircleSpinner } from 'epic-spinners';

export default {
  components: {
    HalfCircleSpinner
  },
  data() {
    return {
      loadingQRcode: true,
      tryCheckStatus: true
    };
  },
  computed: {
      ...mapGetters([
      'cartProducts'
    ]),
   productsTotal() {
      let total = 0;
      let somador = 0;
      this.cartProducts.forEach(p => {
        p.forEach(v => {
          somador += (v.valor + v.valor_conveniencia) * v.quantidade;
        });
      });
      total = somador;
      return total * 100;
    },
    productsDiscount () {
        let total = this.productsTotal
        let discount = total * (0.05)
        return discount
    },
    ameDetails() {
      return this.$store.getters.ameDetails;
    },
    ameIsSelected() {
      return this.$store.getters.ameIsSelected;
    },
    ameOrderStatus() {
      return this.$store.getters.ameOrderStatus;
    },
    pingAme: {
      get () {
        return this.$store.getters.pingAme
      },
      set (val) {
        this.$store.dispatch('setPingAme', val)
      }
    }
  },
  mounted() {
    this.clearIntervalPing()    
  },
  watch: {
      ameDetails () {
          if (this.ameDetails && this.ameDetails.order_hash && this.tryCheckStatus) {
              this.checkPurchaseStatus()
          }
          if (this.ameDetails && this.ameDetails.wallet_qrcode) {
            setTimeout(() => {
              this.loadingQRcode = false
            }, 1500) 
          }
      },
      ameOrderStatus (v) {
        if (v.status === 'waiting_payment') {
        }
        if (v.status === 'paid' && v.orderData) {
           clearInterval(this.pingAme)
           this.tryCheckStatus = false

            const postOrder = {
              ...this.$store.getters.postOrder,
              status: 'Aprovado',             
              hash_pedido: this.$store.getters.body.hash_pedido,
              payment: this.$store.getters.paymentOption,
              organizador: v.orderData.nome_organizador,
              cpf_organizador: v.orderData.org_cpf,
              cnpj_organizador: v.orderData.org_cnpj,
              mensagem: v.orderData.mensagem_conclusao_pedido
            };

            this.$store.dispatch('setPostOrder', postOrder);
            this.$store.commit('SET_TICKET_URL', v.orderData.ticketsUrl);
            console.log('setPurchaseStarted - ameOrderStatus - false')
            this.$store.dispatch('setPurchaseStarted', false);
            this.$store.dispatch('nextStep')
            // this.$store.dispatch('confirmOrder');
        }
      }
  },
  methods: {
      clearIntervalPing () {
          clearInterval(this.pingAme)
      },
      returnToOptions () {
         this.$store.commit('SET_SECOND_PAYMENT_STEP', false)
          this.$store.commit('SET_AME_SELECTED', false)
          this.$store.commit('SET_AME_DETAILS', null)
          this.$store.commit('SET_AME_ORDER_STATUS', null)
          clearInterval(this.pingAme)
      },
      checkPurchaseStatus () {
        var ame = this.ameDetails
        var store = this.$store
        this.pingAme = setInterval(async function (){ 
                try {
                    const { data } = await $http.get(`https://soulapi.homolog.btservers.com.br/api/pdv/orders/charge/status?order_hash=${ame.order_hash}`);
                    store.commit('SET_AME_ORDER_STATUS', data)
                } catch (error) {
                    throw error;
                }      
        }, 3000);
      }
  }
};
</script>

<style scoped>
.link-btn{
    color: #1976D2;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
}

.title-card{
    color: #192B46;
    font-size: 20px;
    font-weight: bold;
}

.subtitle-card{
    color: #192B46;
    font-size: 16px;
    font-weight: 500;
}

.discount {
    color: #00A65A;
    font-size: 16px;
    font-weight: 500;
}
.footer-card {
    color: #1976D2;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
}
</style>

<style>
.half-circle-spinner.loading-circular {
  position: relative !important;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 10px !important;
  z-index: 100000;
}
</style>
